import { UIKitIcon } from '../icon';

export const sheetIcon: UIKitIcon = {
  name: 'sheet',
  // tslint:disable-next-line: max-line-length
  data: '<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 26H8V6h16v16l-4 4ZM12 13h8M12 16h8M12 '
  + '10h8" stroke="#fff" stroke-miterlimit="10"/><path d="M24 22h-4v4" stroke="#fff" stroke-miterlimit="10"/></svg>',
};
